import { render, staticRenderFns } from "./DynamicFutureLevelsConf.vue?vue&type=template&id=89448e84"
import script from "./DynamicFutureLevelsConf.vue?vue&type=script&lang=js"
export * from "./DynamicFutureLevelsConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports